"use client"

import { Link } from "~/components/legacy/common/link"
import { Stack } from "~/components/legacy/common/stack"
import { LoginForm } from "~/components/web/auth/login-form"

export const Login = () => {
  return (
    <Stack direction="column" className="items-stretch w-full">
      <LoginForm />

      <p className="mt-2 text-center text-xs text-muted-foreground">
        Learn how we handle your data in our{" "}
        <Link href="/privacy" target="_blank" rel="noopener noreferrer" className="underline">
          Privacy Policy
        </Link>
        .
      </p>
    </Stack>
  )
}
